import React from "react";
import { useAuthToken } from "../hooks/useAuthToken";

const Logout = () => {
  const authToken = useAuthToken();

  if (authToken.status !== "ok") {
    return "You are not logged in";
  }

  return (
    <div className="flex justify-center items-center">
      <button className="btn btn-error btn-outline" onClick={authToken.logout}>
        Abmelden
      </button>
    </div>
  );
};
export default React.memo(Logout);
